document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".bannerSlider").forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      effect: "slide",
      speed: 2000,
      autoplay: {
        delay: 4000,
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".categoryBoxSlider").forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: true,
      speed: 500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".next-for-collection",
        prevEl: ".prev-for-collection",
      },

      pagination: false,

      breakpoints: {
        1281: { slidesPerView: 4, spaceBetween: 10 },
        769: { slidesPerView: 3 },
        576: { slidesPerView: 2 },
        300: { slidesPerView: 1.2, spaceBetween: 5 },
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".prodArtistSlider").forEach((slider) => {
    const parent = slider.closest(".articalSliderMain");

    new Swiper(slider, {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: true,
      speed: 1000,

      navigation: {
        nextEl: parent.querySelector(".next-for-artist"),
        prevEl: parent.querySelector(".prev-for-artist"),
      },

      breakpoints: {
        1281: { slidesPerView: 4, spaceBetween: 10 },
        769: { slidesPerView: 3 },
        576: { slidesPerView: 2 },
        300: { slidesPerView: 1.2, spaceBetween: 5 },
      },
    });
  });
});


// Update Pruduct Slider

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".prodCardSlider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.5,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}




// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".prodCardSlider").forEach((slider) => {
//     const wrapper = slider.querySelector(".swiper-wrapper");
//     const originalSlides = slider.querySelectorAll(".swiper-slide");

//     // const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
//     // for (let i = 0; i < clones; i++) {
//     //   originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
//     // }

//     const swiper = new Swiper(slider, {
//       slidesPerView: 4.1,
//       spaceBetween: 10,
//       loop: true,
//       centeredSlides: false,
//       speed: 1000,
//       pagination: false,
//       breakpoints: {
//         1025: {
//           slidesPerView: 4.1,
//           spaceBetween: 10,
//         },
//         769: {
//           slidesPerView: 3.3,
//         },
//         576: {
//           slidesPerView: 2.3,
//         },
//         300: {
//           slidesPerView: 1.2,
//           spaceBetween: 5,
//         },
//       },
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".testiMonialSlider").forEach((slider) => {
    const wrapper = slider.querySelector(".swiper-wrapper");
    const originalSlides = slider.querySelectorAll(".swiper-slide");
    const paginationEl = slider.querySelector(".swiper-pagination");

    const TOTAL_BULLETS = 3;

    paginationEl.innerHTML = "";
    for (let i = 0; i < TOTAL_BULLETS; i++) {
      const bullet = document.createElement("span");
      bullet.className = "swiper-pagination-bullet";
      paginationEl.appendChild(bullet);
    }

    const bullets = paginationEl.querySelectorAll(".swiper-pagination-bullet");

    const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
    for (let i = 0; i < clones; i++) {
      originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
    }

    const swiper = new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      speed: 1000,
      pagination: false,
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        300: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });

    swiper.on("slideChange", function () {
      let real = swiper.realIndex;

      let activeBullet = real % TOTAL_BULLETS;

      bullets.forEach((b) =>
        b.classList.remove("swiper-pagination-bullet-active"),
      );

      bullets[activeBullet].classList.add("swiper-pagination-bullet-active");
    });

    bullets.forEach((bullet, i) => {
      bullet.addEventListener("click", () => {
        swiper.slideToLoop(i);
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".impactSliderSlides").forEach((slider) => {
    const wrapper = slider.querySelector(".swiper-wrapper");
    const originalSlides = slider.querySelectorAll(".swiper-slide");
    const paginationEl = slider.querySelector(".swiper-pagination");

    const TOTAL_BULLETS = 3;

    paginationEl.innerHTML = "";
    for (let i = 0; i < TOTAL_BULLETS; i++) {
      const bullet = document.createElement("span");
      bullet.className = "swiper-pagination-bullet";
      paginationEl.appendChild(bullet);
    }

    const bullets = paginationEl.querySelectorAll(".swiper-pagination-bullet");

    const clones = parseInt(slider.dataset.cloneMultiplier, 10) || 2;
    for (let i = 0; i < clones; i++) {
      originalSlides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
    }

    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      speed: 1000,
      pagination: false,
      breakpoints: {
        1025: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 1.8,
          spaceBetween: 10,
        },
        300: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
      },
    });

    swiper.on("slideChange", function () {
      let real = swiper.realIndex;

      let activeBullet = real % TOTAL_BULLETS;

      bullets.forEach((b) =>
        b.classList.remove("swiper-pagination-bullet-active"),
      );

      bullets[activeBullet].classList.add("swiper-pagination-bullet-active");
    });

    bullets.forEach((bullet, i) => {
      bullet.addEventListener("click", () => {
        swiper.slideToLoop(i);
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swiperWrapper = document.querySelector(".logoSlider .swiper-wrapper");

  if (!swiperWrapper) return;

  const slide = swiperWrapper.querySelector(".swiper-slide");

  // Clone slides
  if (slide) {
    for (let i = 0; i < 10; i++) {
      swiperWrapper.appendChild(slide.cloneNode(true));
    }
  }

  // === Uniform Speed Fix ===
  function getSliderSpeed() {
    const totalWidth = swiperWrapper.scrollWidth; // total slider width in px
    const baseSpeed = 500; // px per second (ADJUST THIS VALUE FOR SPEED)
    return (totalWidth / baseSpeed) * 1000; // milliseconds
  }

  const uniformSpeed = getSliderSpeed();

  var swiper = new Swiper(".logoSlider", {
    slidesPerView: "auto",
    loop: true,
    spaceBetween: 100,
    breakpoints: {
      150: { spaceBetween: 40 },
      576: { spaceBetween: 30 },
      769: { spaceBetween: 60 },
      1025: { spaceBetween: 100 },
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: uniformSpeed, // Dynamic uniform speed
  });
});
